<template>
  <div>
    <v-card flat>
      <v-row no-gutters>
        <v-col class="py-0" cols="12" sm="12" md="12">
          <v-row no-gutters>
            <v-col
              class="py-0 d-flex flex-row align-center"
              cols="12"
              md="6"
              sm="12"
            >
              <h3 class="font-weight-bold align">Manage User Roles</h3>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="py-1 d-flex flex-row" cols="12" md="6" sm="12">
              <v-select
                v-model="selectedRoleText"
                :items="roles"
                item-text="role"
                outlined
                dense
                hide-details
                menu-props="offset-y"
                @change="changeSelectedRole"
              >
              </v-select>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    icon
                    class="ml-2 flex-grow-1"
                    v-bind="attrs"
                    @click="showCreateRole"
                    v-on="on"
                  >
                    <v-icon> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <p class="white--text">Create a new role</p>
              </v-tooltip>
              <!-- TODO: Add the delete role button at the bottom of this page -->
              <!-- <v-btn color="error" rounded depressed class="ml-2 flex-grow-1" @click="deleteRole">
                <v-icon> mdi-minus </v-icon>
              </v-btn> -->
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="selectedRole" no-gutters class="d-flex flex-column">
        <v-list-group
          v-for="(feature, featureKey) in featuresInfo"
          :key="featureKey"
          :value="true"
        >
          <template v-slot:activator>
            <v-row no-gutters>
              <span class="body-1">
                {{ featuresInfo[featureKey]['text'] }}
              </span>
            </v-row>
          </template>
          <v-list-item v-for="(value, key) in feature.access" :key="key" dense>
            <v-switch
              :key="selectedRole.role"
              v-model="
                rolesModels[selectedRole.role]['features'][featureKey][key]
              "
              :label="featuresInfo[featureKey]['access'][key]"
              hide-details
              dense
              class="mt-0 mb-3"
            >
            </v-switch>
          </v-list-item>
        </v-list-group>
      </v-row>
    </v-card>
    <v-dialog v-model="createRoleDialog" max-width="300">
      <v-card>
        <v-container
          fluid
          :class="{
            'px-10': !mobile,
            'pt-8': !mobile,
            'px-4': mobile
          }"
        >
          <p class="subtitle-1 font-weight-bold">Create New Role</p>
          <v-card-text class="pa-0">
            <v-form
              ref="createRoleForm"
              v-model="createRoleForm"
              @submit.prevent="createRole"
            >
              <v-text-field
                v-model="newRole"
                :rules="[rules.required]"
                label="Enter New Role Name"
                outlined
                dense
                class="mt-4"
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions :class="{ 'pt-4': !mobile, 'pt-1': mobile }">
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              text
              color="primary darken-1"
              @click="createRole"
            >
              CREATE
            </v-btn>
            <v-btn
              class="font-weight-bold"
              text
              color="grey darken-1"
              @click="closeCreateRole"
            >
              CANCEL
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      snackbar: false,
      snackbarMessage: '',
      tab: null,
      roles: [],
      rolesModels: {},
      selectedRole: null,
      selectedRoleText: null,
      featuresInfo: {}, //responsible for which features will be displayed, received from back-end
      newRole: null,
      createRoleDialog: false,
      createRoleForm: false,
      rules: {
        required: (value) => !!value || 'Required.'
      }
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  async mounted() {
    await this.reloadRoles()
  },
  methods: {
    async reloadRoles() {
      this.$root.$setLoading(true)
      const rolesInfo = await this.$store.dispatch('roles/getAllRoles') //for roles and checkboxes for roles
      this.roles = rolesInfo.roles
      this.featuresInfo = rolesInfo.featuresInfo
      this.selectedRole = this.roles[0]
      this.selectedRoleText = this.roles[0]
      for (let role of this.roles) {
        this.rolesModels[role.role] = {}
        this.rolesModels[role.role].features = {}
        this.rolesModels[role.role].roleId = role.roleId
        for (let feature of role.features) {
          if (this.featuresInfo[feature.feature]) {
            this.rolesModels[role.role]['features'][feature.feature] = {
              ...feature.access
            }
          }
        }
      }
      this.$root.$setLoading(false)
    },
    changeSelectedRole() {
      this.selectedRole = this.roles.find(
        ({ role }) => role === this.selectedRoleText
      )
    },
    showCreateRole() {
      this.createRoleDialog = true
    },
    closeCreateRole() {
      this.createRoleDialog = false
    },
    async createRole() {
      try {
        if (this.$refs.createRoleForm.validate()) {
          this.loading = true

          await this.$store.dispatch('roles/createRole', { role: this.newRole })
          await this.reloadRoles()
          this.createRoleDialog = false
          this.selectedRole = this.roles[this.roles.length - 1] //select newly created role
          this.selectedRoleText = this.roles[this.roles.length - 1]
          this.loading = false
        }
      } catch (err) {
        this.snackbar = true
        this.snackbarMessage = err.response.data
          ? err.response.data
          : err.message
        this.loading = false
      }
    },
    async deleteRole() {
      const roleId = this.selectedRole.roleId
      const dialogOptions = {
        title: 'Delete Role',
        message: 'Are you sure you want to delete this role?',
        confirmText: 'CONFIRM'
      }
      try {
        const resolve = await this.$root.$confirm(dialogOptions)
        if (resolve) {
          this.loading = true
          await this.$store.dispatch('roles/deleteRole', { roleId })
          await this.reloadRoles()
          this.selectedRole = this.roles[0]
          this.selectedRoleText = this.roles[0]
          this.loading = false
        }
      } catch (err) {
        this.snackbar = true
        this.snackbarMessage = err.response.data
          ? err.response.data
          : err.message
        this.loading = false
      }
    }
  }
}
</script>

<style scoped></style>
